export default "__VITE_ASSET__42b1160b__"